import { AfterViewInit, Directive, ElementRef, ViewChild } from '@angular/core';
import { DashboardNodeComponent } from './dashboard-node.component';
import { DOMEvent, ViewSelector } from './dom.constant';
import { Collapse } from '../core/dashboard.node';

@Directive()
export abstract class CollapseComponent
  extends DashboardNodeComponent<Collapse>
  implements AfterViewInit
{
  @ViewChild(ViewSelector.COLLAPSE, { read: ElementRef })
  protected collapse!: ElementRef;
  private listeningToDragEvents!: boolean;
  private timeout: any;

  ngAfterViewInit(): void {
    this.listenToDragEventsIfEditMode();
  }

  protected listenToDragEventsIfEditMode(): void {
    if (this.editMode && !this.listeningToDragEvents) {
      this.collapse.nativeElement?.addEventListener(
        DOMEvent.DRAG_ENTER,
        ($event: Event) => {
          $event.stopPropagation();
          this.timeout = setTimeout(() => {
            if (!this.node.isExpanded) {
              this.node.expand();
            }
          }, this.dragFocusTimeout);
        }
      );

      this.collapse.nativeElement.nativeElement?.addEventListener(
        DOMEvent.DRAG_LEAVE,
        ($event: Event) => {
          $event.stopPropagation();
          clearTimeout(this.timeout);
        }
      );

      this.listeningToDragEvents = true;
    }
  }
}
